import React, { FC } from 'react';
import { useRouter } from 'next/router';
import BroadcastBoats from 'src/inquiry/components/BroadcastBoats';
import InquiryBroadcastErrors from 'src/inquiry/components/InquiryBroadcastErrors';
import { EXTERNAL_PATHS } from 'src/common/constants';
import type { InquiryBroadcastPageServerProps } from 'pages/trips/[listing_id]/inquiry/broadcast';

const InquiryBroadcastPage: FC<{ props: InquiryBroadcastPageServerProps }> = ({ props }) => {
  const { push } = useRouter();

  if (props.type === 'error') {
    return (
      <InquiryBroadcastErrors
        error={props.error}
        context="broadcast-from-email-2hr"
        inquiryId={props.inquiryId}
      />
    );
  }

  return (
    <BroadcastBoats
      context="broadcast-from-email-2hr"
      broadcastBoats={props.broadcastBoats}
      inquiryId={props.inquiryId}
      listing={props.listing}
      onContinue={() => push(`${EXTERNAL_PATHS.INBOX}${props.tripId}/`)}
    />
  );
};

export default InquiryBroadcastPage;
